import { createReducer, on } from "@ngrx/store"
import * as authorizerActions from './authorizers.actions';

export interface AuthorizerState {
    merchantAuthorizers: []
    fetchMerchantAuthorizersError: boolean
    loadingMerchantAuthorizers: boolean
}

export const initialState: AuthorizerState = {

    merchantAuthorizers: null,
    fetchMerchantAuthorizersError: null,
    loadingMerchantAuthorizers: null,

}

export const AuthorizerReducer = createReducer(
    initialState,


    on(authorizerActions.fetchMerchantAuthorizers, (state) => ({
        ...state, merchantAuthorizers: null, fetchMerchantAuthorizersError: null, loadingMerchantAuthorizers: true
    })),

    on(authorizerActions.fetchMerchantAuthorizersSuccess, (state, {authorizers}) => ({
        ...state, merchantAuthorizers: authorizers, fetchMerchantAuthorizersError: false, loadingMerchantAuthorizers: false
    })),

    on(authorizerActions.fetchMerchantAuthorizersFailed, (state) => ({
        ...state, merchantAuthorizers: null, fetchMerchantAuthorizersError: true, loadingMerchantAuthorizers: false
    })),


)